export const environment = {
  production: false,
  auth: {
    apiUrl: 'https://dev-auth-eu-south-2.service.3ddvapis.com',
    appId: '478952'
  }
};